module.exports = __webpack_public_path__ + "static/media/Dashboard_farmers.15b44918.png";